import React from "react";
import {PrivacyPolicy} from "../components/PrivacyPolicy";

export default function PrivacyPolicyPage() {
    return <PrivacyPolicy/>;
}